import React from 'react'
import { Container, Row, Col, Card, Image } from 'react-bootstrap'

import { InSiteIntelligenceSummary, CurrentIQSummary, ConstructionSummary, FiableSummary, DXCSummary } from '../../../experience/experience'

const ExperienceSummary = () => {
    return (
        <section className='mb-0'>
            <Container>
                <h2 className='text-uppercase text-center text-secondary'>Experience</h2>
                <hr className='star-light mb-5'/>
                <Row className='gy-3 justify-content-center'>
                    <ExperienceCardCol data={InSiteIntelligenceSummary} />
                    <ExperienceCardCol data={CurrentIQSummary} />
                    <ExperienceCardCol data={ConstructionSummary} />
                    <ExperienceCardCol data={FiableSummary} />
                    <ExperienceCardCol data={DXCSummary} />
                </Row>
            </Container>
        </section>
    )
}

const ExperienceCardCol = ({data}) => (
    <Col lg={4} md={6} className='d-flex justify-content-center'>
        <Card className='text-center'>
            <Card.Header className='bg-secondary text-white d-flex align-items-center justify-content-center gap-2'>
                <Image src={data.logo} alt='' width={28} height={28} rounded />
                <b>{data.company}</b>
            </Card.Header>
            <Card.Body className='text-start py-0 bg-primary text-secondary'>
                <i>{data.title}</i>
                {data.summary}
            </Card.Body>
            <Card.Footer className='bg-secondary text-white'><em>{data.dateStart}-{data.dateEnd}</em></Card.Footer>
        </Card>
    </Col>
)

export default ExperienceSummary;